const SOFTHYPHEN_ASCII_CODE = '\u00AD'.charCodeAt(0);
const DE_MIN_NUMBER_OF_CHARACTER_LEFT_RIGHT = 4;

const decodeInitialiser = () => {
  const utf16ledecoder = new TextDecoder('utf-16le');
  // eslint-disable-next-line
  // @ts-ignore
  return (ui16) => {
    return utf16ledecoder.decode(ui16);
  };
};

const initialiseHyphenation = (wasmModule: WebAssembly.WebAssemblyInstantiatedSource, hyphenationCharacter?: number) => {
  // Memory layout of the Wasm module
  // https://github.com/mnater/Hyphenopoly/blob/df528e36cd87b8f12313783583ee34d2dfb2539a/tools/calculateBaseData.js#L31
  // The alphabet length from the Wasm module that I know exists.
  // eslint-disable-next-line
  // @ts-ignore
  const alphalen = wasmModule.instance.exports.conv();
  // The heap
  // eslint-disable-next-line
  // @ts-ignore
  const wasmHeap = wasmModule.instance.exports.mem.buffer;
  // https://github.com/mnater/Hyphenopoly/blob/df528e36cd87b8f12313783583ee34d2dfb2539a/tools/calculateBaseData.js#L40-L42
  const decode = decodeInitialiser();
  const alphabet = decode(new Uint16Array(wasmHeap, 1026, alphalen - 1)).replace(/-/g, '');

  // Regex for the alphabet that the Wasm module can handle. Used to identify
  // words that can be hyphenated.
  // Needs to be a function so we initialise the Regex every time we use it.
  // NOTE: Regex with `g` modifier must not be reused.
  // https://stackoverflow.com/questions/9873122/why-is-regex-javascript-g-flag-affecting-state/9873228#9873228
  const regexString = `[${alphabet}a-z\u00DF-\u00F6\u00F8-\u00FE\u0101\u0103\u0105\u0107\u0109\u010D\u010F\u0111\u0113\u0117\u0119\u011B\u011D\u011F\u0123\u0125\u012B\u012F\u0131\u0135\u0137\u013C\u013E\u0142\u0144\u0146\u0148\u014D\u0151\u0153\u0155\u0159\u015B\u015D\u015F\u0161\u0165\u016B\u016D\u016F\u0171\u0173\u017A\u017C\u017E\u017F\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u0219\u021B\u02BC\u0390\u03AC-\u03CE\u03D0\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF\u03F2\u0430-\u044F\u0451-\u045C\u045E\u045F\u0491\u04AF\u04E9\u0561-\u0585\u0587\u0905-\u090C\u090F\u0910\u0913-\u0928\u092A-\u0930\u0932\u0933\u0935-\u0939\u093D\u0960\u0961\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A85-\u0A8B\u0A8F\u0A90\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AE0\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B60\u0B61\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB5\u0BB7-\u0BB9\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D28\u0D2A-\u0D39\u0D60\u0D61\u0D7A-\u0D7F\u0E01-\u0E2E\u0E30\u0E32\u0E33\u0E40-\u0E45\u10D0-\u10F0\u1200-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u1E0D\u1E37\u1E41\u1E43\u1E45\u1E47\u1E6D\u1F00-\u1F07\u1F10-\u1F15\u1F20-\u1F27\u1F30-\u1F37\u1F40-\u1F45\u1F50-\u1F57\u1F60-\u1F67\u1F70-\u1F7D\u1F80-\u1F87\u1F90-\u1F97\u1FA0-\u1FA7\u1FB2-\u1FB4\u1FB6\u1FB7\u1FC2-\u1FC4\u1FC6\u1FC7\u1FD2\u1FD3\u1FD6\u1FD7\u1FE2-\u1FE7\u1FF2-\u1FF4\u1FF6\u1FF7\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CC9\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E-]{${DE_MIN_NUMBER_OF_CHARACTER_LEFT_RIGHT},}`;
  const regex = () => {
    // https://github.com/mnater/Hyphenopoly/pull/110/files
    return RegExp(regexString, 'gui');
  };

  const hyphenateWord = (word: string) => {
    // eslint-disable-next-line
    // @ts-ignore
    const exp = wasmModule.instance.exports;
    // eslint-disable-next-line
    // @ts-ignore
    const heapBuffer = exp.mem.buffer;
    // eslint-disable-next-line
    // @ts-ignore
    const wordStore = new Uint16Array(heapBuffer, exp.uwo.value, 64);
    // eslint-disable-next-line
    // @ts-ignore
    const hydWrdStore = new Uint16Array(heapBuffer, exp.hwo.value, 128);
    // eslint-disable-next-line
    // @ts-ignore
    let i = 0;
    // eslint-disable-next-line
    // @ts-ignore
    let cc = word.charCodeAt(i);
    while (cc) {
      i += 1;
      wordStore[i] = cc;
      // eslint-disable-next-line
      // @ts-ignore
      cc = word.charCodeAt(i);
    }
    wordStore[0] = 95;
    wordStore[i + 1] = 95;
    wordStore[i + 2] = 0;
    // eslint-disable-next-line
    // @ts-ignore
    exp.hyphenate(
      DE_MIN_NUMBER_OF_CHARACTER_LEFT_RIGHT,
      DE_MIN_NUMBER_OF_CHARACTER_LEFT_RIGHT,
      hyphenationCharacter || SOFTHYPHEN_ASCII_CODE,
    );
    // eslint-disable-next-line
    // @ts-ignore
    return decode(hydWrdStore.subarray(1, hydWrdStore[0] + 1));
  };

  const hyphenateCompound = (word: string) => {
    return word.split('-').map(hyphenateWord).join('-');
  };

  return (inputString: string) => {
    return inputString.replace(regex(), (match) => {
      // If a word contains a hyphen it is a compound word. We need to hyphenate
      // each of the words without the hyphen and rejoin them afterwards.
      if (match.indexOf('-') === -1) {
        return hyphenateWord(match);
      } else {
        return hyphenateCompound(match);
      }
    });
  };
};

export {initialiseHyphenation};
